import { BackendCategory, Category } from '../types/entities'

const mapBackendCategories = (backendCategories: BackendCategory[]): Category[] => (
  backendCategories.map(({
    id,
    name,
    html_url: htmlURL,
    icon_color_light: iconColorLight,
    icon_name: iconName,
  }) => ({
    id,
    name,
    htmlURL,
    iconColorLight,
    iconName,
  }))
)

export { mapBackendCategories }
